module.exports = __webpack_public_path__ + "media/newsletter_page/primary_interests-a1ead96b.svg";